import React from "react";

import { PlatformType } from "./usePlatformType";

export const PlatformTypeContext = React.createContext<PlatformType>({
  isMobile: true,
  isIos: false,
  browser: undefined,
  browserVersion: undefined,
  os: undefined,
  osVersion: undefined,
});
